import { render } from "./Recapitulatif.vue?vue&type=template&id=0b4c75cc"
import script from "./Recapitulatif.vue?vue&type=script&lang=js"
export * from "./Recapitulatif.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__